import React from "react";
import { Badge } from "@/shared/components/ui/badge";
import { CheckCircle2, XCircle, Clock, AlertCircle } from "lucide-react";
import { cn } from "@/shared/lib/utils";

export const EntityStatusBadge = ({ status, t, className }) => {
  const s = status?.toUpperCase() || "UNKNOWN";

  const getConfig = () => {
    switch (s) {
      case "ACTIVE":
        return {
          label: t ? t("active") : "Active",
          variant: "outline",
          className: "border-emerald-200 bg-emerald-50 text-emerald-700 shadow-sm shadow-emerald-100/50",
          icon: <CheckCircle2 className="w-3 h-3 mr-1.5" />,
        };
      case "SUSPENDED":
      case "INACTIVE":
        return {
          label: t ? t("suspended") : "Suspended",
          variant: "outline",
          className: "border-amber-200 bg-amber-50 text-amber-700 shadow-sm shadow-amber-100/50",
          icon: <XCircle className="w-3 h-3 mr-1.5" />,
        };
      case "PENDING":
        return {
          label: t ? t("pending") : "Pending",
          variant: "outline",
          className: "border-blue-200 bg-blue-50 text-blue-700 shadow-sm shadow-blue-100/50",
          icon: <Clock className="w-3 h-3 mr-1.5" />,
        };
      case "DELETED":
        return {
          label: t ? t("deleted") : "Deleted",
          variant: "outline",
          className: "border-red-200 bg-red-50 text-red-700 shadow-sm shadow-red-100/50",
          icon: <AlertCircle className="w-3 h-3 mr-1.5" />,
        };
      default:
        return {
          label: status || "Unknown",
          variant: "outline",
          className: "border-slate-200 bg-slate-50 text-slate-600",
          icon: null,
        };
    }
  };

  const config = getConfig();

  return (
    <Badge
      variant={config.variant}
      className={cn(
        "px-2.5 py-0.5 rounded-full font-semibold text-[11px] inline-flex items-center transition-all duration-300",
        config.className,
        className
      )}
    >
      {config.icon}
      {config.label}
    </Badge>
  );
};
